import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-edit-material-modal',
  templateUrl: './edit-material-modal.component.html',
  styleUrls: ['./edit-material-modal.component.scss']
})
export class EditMaterialModalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
